import { useI18n } from '~/hooks/use-i18n';

import { CatalogCardWithBasicItem } from '../components/catalog-card-program';
import { CatalogCardItem } from '../models/catalog-card-item';
import { CatalogItem } from '../models/catalog-item';
import { CatalogSearchItem } from '../models/catalog-search-result';
import { getTranslatedLocaleConfig } from '../utils/catalog-locale';

type CatalogItemUnion = CatalogItem | CatalogCardItem | CatalogSearchItem;

export function useLocaleCatalogTitleSummary({
  catalogItem,
  basicItem,
}: {
  catalogItem?: CatalogItemUnion;
  basicItem?: CatalogCardWithBasicItem['basicItem'];
}) {
  const { i18n } = useI18n();

  if (!catalogItem) {
    return { catalogTitle: basicItem?.title ?? '', catalogSummary: undefined };
  }

  const catalogTitle = catalogItem.title ?? '';
  const catalogSummary = 'summary' in catalogItem ? catalogItem.summary : undefined;

  // Show the translated title/summary for the user's language when available,
  // falling back to the default (English) values.
  const localeConfig = getTranslatedLocaleConfig(i18n.language);
  const translation =
    localeConfig && 'translations' in catalogItem ? catalogItem.translations?.[localeConfig.localeCode] : undefined;

  return {
    catalogTitle: translation?.title ? translation.title : catalogTitle,
    catalogSummary: translation?.summary ? translation.summary : catalogSummary,
  };
}
